import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DialogContent,
  DialogActions,
  DialogTitle,
  Typography,
  Divider,
  Box,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import actions from '@src/redux/actions';
import { CancelRounded, FlagRounded } from '@mui/icons-material';
import { COLOR } from '@src/styles/color';
import apis from '@src/apis';
import { StyledButton, StyledDialog } from './index.style';

const ReportErrorRequestDialog = ({ open, onClose, request }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState('');

  const handleSendReport = async () => {
    if (!description) {
      return;
    }
    setLoading(true);

    const response = await apis.requests.createErrorReport(
      request?.latestRequestId || request.id,
      description,
    );
    setLoading(false);
    onClose();
    if (response && response?.status) {
      dispatch(
        actions.noti.push({
          severity: 'success',
          message: 'sendErrorReportSuccess',
        }),
      );
      return;
    }
    dispatch(
      actions.noti.push({
        severity: 'error',
        message: 'sendErrorReportFailure',
      }),
    );
  };

  const MAX_LENGTH_DESC = 500;
  const onChangeDescription = (e) => {
    if (e.target.value.length > MAX_LENGTH_DESC) {
      setDescription(e.target.value.slice(0, MAX_LENGTH_DESC));
      return;
    }
    setDescription(e.target.value);
  };

  return (
    <StyledDialog open={open} onClose={onClose} fullWidth>
      <DialogTitle className="wrap-title">
        <Box className="title">
          <FlagRounded sx={{ color: '#FF3B30' }} />
          <Typography className="text-title">{t('errorReport')}</Typography>
        </Box>
        <CancelRounded sx={{ color: COLOR.darkV2[32] }} onClick={onClose} />
      </DialogTitle>
      <Divider />
      <DialogContent className="wrap-content">
        <textarea
          value={description}
          onChange={onChangeDescription}
          rows={5}
          className="text-area-input"
          placeholder={t('errorReportPlaceholder')}
        />
      </DialogContent>
      <DialogActions className="wrap-actions">
        <StyledButton
          variant="contained"
          onClick={handleSendReport}
          bgrDisble={COLOR.yellow[32]}
          colorDisable="#3c164e99"
          disabled={loading || !description}
        >
          {t('sendErrorReport')}
        </StyledButton>
      </DialogActions>
    </StyledDialog>
  );
};

export default ReportErrorRequestDialog;
